import { motion } from 'framer-motion';

export const ShimmerLoader = ({
  height,
  width,
}: {
  height: number;
  width: number;
}) => {
  return (
    <div
      className="relative h-6 w-full overflow-hidden rounded-full bg-interface-shimmer"
      style={{
        ...(height && { height: `${height}px` }),
        ...(width && { width }),
      }}
    >
      <motion.div
        className="via-[hsla(228, 59%, 88%, 0.4)] absolute inset-0 rounded-full bg-gradient-to-r from-interface-shimmer to-interface-shimmer"
        animate={{ x: ['-100%', '100%'] }}
        transition={{ repeat: Infinity, duration: 1.5, ease: 'linear' }}
      />
    </div>
  );
};
